import { useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useDossier } from "../../../hooks/useDossier";
import { Dossier } from "../../../models/Dossier";
import { GeoJSON, Pane } from 'react-leaflet';

//Bootstrap
import { Card, InputGroup, Button, Row, Col, Badge, Accordion, Spinner, Tooltip, OverlayTrigger } from "react-bootstrap";
import { useMapInfo } from "../../../hooks/useMapInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faDownload, faEye, faEyeSlash, faHouse, faLocationCrosshairs, faSquare, faSquareFull, faX } from "@fortawesome/free-solid-svg-icons";
import { faSquare as faSquareRegular } from "@fortawesome/free-regular-svg-icons";
import { useCarto } from "../../../hooks/useCarto";
import { useApi } from "../../../hooks/useApi";
import { Feature, FeatureCollection } from "geojson";
import { DomEvent, latLng, Layer } from "leaflet";
import L from "leaflet";
import { TransactionModal } from "./TransactionModal";
import { DocumentsUrbanisme } from "./DocumentsUrbanisme";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

//Params

export const ZonesUrbaineCard = () => {
    /**
     * Hooks
     */
    const { carto, getLayerColor, handleShowHideFeature, handleShowFeatures, handleHideFeatures, setSelectedCard } = useCarto();
    const divContainer = useRef<HTMLDivElement>(null);

    /**
     * States
     */
    const [showAllFeatures, setShowAllFeatures] = useState(false);

    /**
     * Constants
     */
    
    /**
     * useEffect
     */
    useEffect(() => {
        if(divContainer.current) {
            DomEvent.disableScrollPropagation(divContainer.current);
        }
    }, [divContainer, carto.selectedParcelle]);

    /**
     * Handlers
     */
    const handleClose = () => {
        setSelectedCard(null);
    }

    const toggleShowHideAllFeatures = () => {
        setShowAllFeatures(!showAllFeatures);
        if(!showAllFeatures) {
            handleShowFeatures(carto.zonesUrbaine.features);
        } else {
            handleHideFeatures(carto.zonesUrbaine.features);
        }
    }

    /**
     * Functions
     */

    /**
     * Render
     */
    if(!carto.selectedParcelle) return null;

    return (
        <div>
            <Card className="card-cadastre mt-2" style={{ width: '500px', maxHeight: 'calc(100vh - 20px)' }}>
                <Card.Body>
                    <Row>
                        <Col className="d-flex mb-0 justify-content-between">
                            <span>Zonage de la parcelle</span>
                            <div>
                                <OverlayTrigger
                                    placement='bottom'
                                    overlay={(
                                        <Tooltip id="tooltip">
                                            {showAllFeatures?"Cacher toutes les zones":"Afficher toutes les zones"}
                                        </Tooltip>
                                    )}>
                                    <FontAwesomeIcon icon={showAllFeatures?faEyeSlash:faEye} style={{ cursor: 'pointer' }} onClick={toggleShowHideAllFeatures} />
                                </OverlayTrigger>
                                <FontAwesomeIcon icon={faX} style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={handleClose} />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mb-1 h3">
                            {carto.selectedParcelle.properties.prefixe} / {carto.selectedParcelle.properties.section} / {carto.selectedParcelle.properties.numero} - {carto.selectedParcelle.properties.contenance} m²
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col>
                            {!carto.zonesUrbaine || carto.zonesUrbaine?.features?.length == 0 ? (
                                <div className="text-muted">
                                    Aucune zone trouvée pour cette parcelle
                                </div>
                            ) : (
                                <>
                                    {carto.zonesUrbaine && carto.zonesUrbaine.features.map((zone) => (
                                        <div key={zone.properties.id}>
                                            <FontAwesomeIcon size="lg" icon={carto.showedFeatures?(carto.showedFeatures.features.find((showedFeature) => showedFeature.properties.id == zone.properties.id)?faSquare:(faSquareRegular as IconProp)):(faSquareRegular as IconProp)} color={getLayerColor(zone)} style={{ cursor: 'pointer', marginLeft: '10px' }} onClick={() => handleShowHideFeature(zone)} /> <strong>{zone.properties.label}</strong>{zone.properties.labelong?' - '+zone.properties.labelong:''}
                                        </div>
                                    ))}
                                </>
                            )}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </div>
    );
}
